import {Pressable, View} from "react-native";
import React from "react";
import {CommonActions, NavigationContext} from "@react-navigation/native";

import {styles} from "./styles";
import ArrowBackIcon from "../icons/ArrowBackIcon";
import AccountSettingsIcon from "../icons/AccountSettingsIcon";

export const WhiteViewHeader = ({
    children,
    showMenuWithChildren,
    onPressMenuIcon,
    onPressBack: customOnPressBack,
}) => {
    const navigation = React.useContext(NavigationContext);

    function onPressBack() {
        if (customOnPressBack) {
            customOnPressBack();
        } else {
            navigation.dispatch(CommonActions.goBack());
        }
    }

    return (
        <View style={styles.whiteViewHeaderView}>
            <Pressable onPress={onPressBack} color={"none"} ><ArrowBackIcon style={styles.backButton}/></Pressable>
            { children && <Pressable onPress={onPressMenuIcon} color={"none"} ><AccountSettingsIcon /></Pressable>}
            { showMenuWithChildren && <View style={styles.whiteViewHeaderMenuView}>{children}</View> }
        </View>
    )
}
